export const SET_CEDULA_TYPE = "SET_CEDULA_TYPE";
export const SET_PETITION_FORM = "SET_PETITION_FORM";
